import { useUserProfileContext } from "@context/user_profile";
import { Navigate, Outlet } from "react-router";
import { LoaderIcon } from "lucide-react";
import { getPostAuthLandingPath } from "@util/auth-redirect";

export default function GuestRoute() {
    const [isLoadingUserProfile, userInfo] = useUserProfileContext();
    if (isLoadingUserProfile) return (
        <div className="fixed inset-0 flex items-center justify-center bg-white">
            <LoaderIcon className="h-8 w-8 animate-spin text-gray-400" />
        </div>
    );

    if (userInfo) {
        // One helper decides where an authenticated session belongs, here and
        // at login and on every logo click. This used to hardcode "/dashboard"
        // with its own copy of the demo-practice rule, which meant a signed-in
        // user landing on "/" was sent to the recruiter dashboard whatever
        // product they actually belong to — and for a receptionist that ended
        // at /unauthorized, because the dashboard dispatches on role and had no
        // branch for them. Two places to teach about a new product is one too
        // many; the helper already knew about Oura and the Receptionist.
        return <Navigate to={getPostAuthLandingPath(userInfo.role, userInfo.company_type)} />
    }

    return <Outlet />
}